import { render, staticRenderFns } from "./sample-orders.vue?vue&type=template&id=42511dec&scoped=true"
import script from "./sample-orders.vue?vue&type=script&lang=js"
export * from "./sample-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42511dec",
  null
  
)

export default component.exports